<template>
  <v-container class="main-supplier-select mainWrapElements">
    <img v-if="instance.linktree_logo" class="mx-auto linktree-logo" :src="instance.linktree_logo.thumb" />
    <div v-else class="layout-img-logo" />
    <div class="scrollMobileFix">
    <v-row class="linktree mainWrapBtns">
      <v-col :class="['wrapBtn', 'service_delivery_custom' ]" v-if="instance.slug === 'the-grill-station-burger'">
        <v-btn class="itemBtn" large block @click="execILink('service_delivery')">
          <img src="https://images.cluvi.com/oIG7GxCwFh/thumb_oIG7GxCwFh_moto-domi.png" alt="" class="img-left">
          Domicilios
          <img src="https://images.cluvi.com/zTh9bOeHEp/thumb_zTh9bOeHEp_moto-domi-2.png" class="img-right">
        </v-btn>
      </v-col>
      <v-col v-for="item in customerLinktree" :key="item.url != null && item.url != '' ? item.url : item.target" :class="['wrapBtn', item.target ]">
        <v-btn
          v-if="item.url != '' && item.target === '_blank' || item.target === '_self'"
          class="itemBtn" link large block
          :href="item.url" :target="item.target"
          v-html="item.label"
          @click="sendEventLinktree(item.label)"
        />
        <v-btn v-else class="itemBtn" large block @click="execILink(item.target)" :data-testid="`Main-` + item.target">
          {{ item.label_custom && item.label_custom !== null && item.label_custom !== '' ? item.label_custom : getLabelTranslation(item) }}
        </v-btn>
      </v-col>
      <v-col v-if="instance.linktree_add_suppliers" class="wrapBtn">
        <v-btn
          v-if="instance.labels_buttons.nuestras_tiendas !== undefined && instance.labels_buttons.nuestras_tiendas.toString().length > 0"
          class="itemBtn" large block
          @click="goToBranches()"
          v-html="instance.labels_buttons.nuestras_tiendas"
        />
        <v-btn
          v-else
          class="itemBtn" large block
          @click="goToBranches()"
          v-html="$t('common.nuestras_tiendas')"
        />
      </v-col>
      <v-col v-if="instance.slug === 'semolina' || instance.slug === 'patria'" class="py-0 mt-0" cols="12" sm="6" offset-sm="3">
        <v-btn
          class="mt-2" large block
          v-html="$t('contact_us')"
          @click="goToBranchesWhatsapp()"
        />
      </v-col>
    </v-row>
    <social-networks :instance="instance" />
    </div>
  </v-container>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import { track } from "@/services/track-custom";

export default {
  name: "Main",
  components: {
    SocialNetworks: () => import(/* webpackChunkName: "SocialNetworks" */'@/components/common/SocialNetworks.vue')
  },
  data: () => ({
    modalGps: false
  }),
  created() {
    this.TemplateDisableHeader();
    this.SetAppClass("background-app");
    this.setService("");
    this.linkInstance();
    this.routeToUrl();
  },
  computed: {
    ...mapState('customer', ["instance","supplier"]),
    ...mapGetters('customer', ['getLabels']),
    customerLinktree() {
      let iLinks = [];
      let cLinks = [];
      for (let i = 0; i < this.instance.linktree?.length; i++) {
        let link = this.instance.linktree[i];
        if (link.target === '_blank' || link.target === '_self') cLinks.push(link);
        else iLinks.push(link);
      };
      iLinks = iLinks.concat(cLinks);
      return iLinks;
    }
  },
  methods: {
    ...mapMutations('template', ['SetLoading', 'TemplateDisableHeader', 'SetAppClass']),
    ...mapMutations('order', ['setService', 'SetPurchaseId', 'SetTaPurchaseId', 'SetOtPurchaseId', 'setShoppingCart', 'SetTotalShoppingCart']),
    ...mapMutations('profile', ['setAllowGps']),
    ...mapMutations("customer", ["SetIsPreview"]),
    ...mapMutations('ontable', ["setCountProductsOrdered"]),
    ...mapActions('order', ['setSchedule', 'setDelivery','setTakeAway']),
    goToBranchesWhatsapp() {
      this.sendEventLinktree("BranchWhatsapp");
      this.$router.push({name: "BranchWhatsapp"});
    },
    goToBranches() {
      this.sendEventLinktree("Branch");
      this.$router.push({name: "Branch"});
    },
    execDelivery() {
      this.setDelivery();
      this.$router.push({ name: "SetLocation" });
    },
    execBook() {
      this.$router.push({ name: "BranchToBook" });
    },
    execOnTable() {
      this.$router.push({ name: "BranchOnTable" });
    },
    execTakeAway() {
      this.setTakeAway();
      this.$router.push({ name: "BranchToTakeAway" });
    },
    execSchedule() {
      this.setSchedule();
      this.$router.push({ name: "SetLocation" });
    },
    getLabelTranslation(item) {
      switch (item.target) {
        case 'service_schedule':
          return `${this.$t("schedule")} ${this.getLabels('delivery')}`;
        case 'service_table':
          return this.$t("service.select_popup.on_table_title", {category: this.instance.category_establishment});
        case 'service_delivery':
          return this.getLabels('delivery_title');
        case 'service_book':
          return this.$t("service.select_popup.book_title");
        case 'service_take_away':
          return this.$t("service.select_popup.take_away_title", {category: this.instance.category_establishment});
        default:
          return item.label;
      }
    },
    sendEventLinktree(event){
      track.trackEventCluvi({search_term: event}, "ClickLinktree");
    },
    execILink(target) {
      this.sendEventLinktree(target);
      switch (target) {
        case 'service_schedule':
          this.execSchedule();
          break;
        case 'service_table':
          this.execOnTable();
          break;
        case 'service_delivery':
          this.execDelivery();
          break;
        case 'service_book':
          this.execBook();
          break;
        case 'service_take_away':
          this.execTakeAway();
          break;
      }
    },
    handlePermission() {
      let self = this;
      if (navigator.permissions) {
        navigator.permissions
          .query({name: "geolocation"})
          .then(function (result) {
            self.validateResult(result);
            result.onchange = function () {
              self.validateResult(result);
            };
          });
      }
    },
    validateResult(result) {
      if (result.state === "granted") {
        this.setAllowGps(true);
      }
    },
    closeActiveGps() {
      this.setAllowGps(true);
    },
    linkInstance() {
      try {
        if (this.instance.links.length === 1) {
          let link = this.instance.links[0];
          if (link.type === "on_table") this.execOnTable();
        };
      } catch (error) {
        error;
      };
    },
    goToHomeDelivery() {
      this.$router.push({
        name: "Home",
        params: { supplier_id: this.supplier.slug }
      });
    },
    routeToUrl () {
      if (this.instance.status === 'locked') this.routeInactiveInstance();
      if (this.$route.name === 'Location') this.routeLocationView();
    },
    routeLocationView () {
      this.setDelivery();
      this.$router.push({ name: "SetLocation" });

    },
    routeInactiveInstance () {
      this.$router.push({ name: 'InactiveInstance' });
    },
    cleanOrder() {
      this.SetPurchaseId("");
      this.SetTaPurchaseId("");
      this.SetOtPurchaseId("");
      this.setCountProductsOrdered(0);
      this.setShoppingCart({
        total: 0,
        transaction_status: 'precheckout'
      });
      this.SetTotalShoppingCart(0);
    },
  },
  mounted() {
    this.SetIsPreview(false);
    this.cleanOrder()
    try {
      setTimeout(() => this.SetLoading(false), process.env.VUE_APP_DELAY);
      track.trackView(this, `Main`, `/`);
      track.trackEventCluvi({}, "view main");
      this.handlePermission();
    } catch (error) {
      error;
      this.activeGps = true;
    }
  },
  metaInfo() {
    return {
      title: this.instance.name
    };
  }
};
</script>

<style scoped lang="scss">
  .main-supplier-select {
    overflow-y: hidden !important;
    h2,
    h3 {
      text-align: center;
      color: white;
    }

    display: grid;
    min-height: 80vh;
    align-content: center;
    align-items: center;
    text-align: center;
  }

  .layout-img-logo {
    min-height: 10vh;
  }

  .linktree-logo {
    max-height: 20vh;
    max-width: 50vw !important;
  }
</style>